"use strict";
var PopEngine_1 = require('../PopEngine');
var MutationHandler = (function () {
    function MutationHandler() {
    }
    MutationHandler.prototype.registerObserver = function () {
        var target = document.body;
        var config = {
            attributes: true,
            attributeFilter: ['popgun'],
            childList: true,
            characterData: true,
            subtree: true
        };
        this.observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                this._maybeAddOrRemovePopTarget(mutation);
            }.bind(this));
        }.bind(this));
        this.observer.observe(target, config);
    };
    MutationHandler.prototype.disconnectObserver = function () {
        this.observer.disconnect();
    };
    MutationHandler.prototype._maybeAddOrRemovePopTarget = function (mutation) {
        if (mutation.type === 'childList' && !!mutation.addedNodes.length) {
            Array.prototype.slice.call(mutation.addedNodes).forEach(function (addedNode) {
                if (!!(addedNode instanceof Element) && PopEngine_1.default.isPopTarget(addedNode)) {
                    this._addGroupIdToCache(addedNode);
                }
            }.bind(this));
        }
        else if (mutation.type === 'attributes' && mutation.attributeName === 'popgun') {
            PopEngine_1.default.synchronousHidePop(mutation.target, true);
            this._addGroupIdToCache(mutation.target);
        }
        else if (mutation.type === 'childList' && mutation.removedNodes.length) {
            this._maybeRemoveOpenPopovers(mutation.removedNodes);
        }
    };
    MutationHandler.prototype._maybeRemoveOpenPopovers = function (removedNodes) {
        Array.prototype.slice.call(removedNodes).forEach(function (removedNode) {
            if (!!(removedNode instanceof Element)) {
                var targetList = removedNode.querySelectorAll('[popgun]');
                Array.prototype.slice.call(targetList).forEach(function (target) {
                    PopEngine_1.default.synchronousHidePop(target, true);
                });
            }
        }.bind(this));
    };
    MutationHandler.prototype._addGroupIdToCache = function (el) {
        var groupId = '';
        if (el.hasAttribute('popgun-group')) {
            groupId = el.getAttribute('popgun-group');
        }
        else {
            groupId = Math.random().toString(36).slice(2);
            el.setAttribute('popgun-group', groupId);
        }
    };
    return MutationHandler;
}());
exports.MutationHandler = MutationHandler;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new MutationHandler();
